import React, { useEffect, useState, useRef } from "react";
import Img1 from "./../../assets/Chruch Webp/Awards/0V5A8336 (1) (1).webp";
import Img2 from "./../../assets/Chruch Webp/Awards/WhatsApp Image 2023-07-20 at 10.29.04.webp";
import Img3 from "./../../assets/Chruch Webp/Awards/image_6483441 (1) (1).webp";
import Img4 from "./../../assets/Chruch Webp/Awards/image_6483441 (1).webp";

const TwoRowLayout = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (!sectionRef.current) return;
  
    const element = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true); // Set true once and never revert to false
        }
      },
      { threshold: 0.2 } // Adjust as needed
    );
  
    observer.observe(element);
  
    return () => {
      observer.unobserve(element);
    };
  }, []);
  
  

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
  
    // Set initial width
    handleResize();
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  

  // Responsive styles dynamically calculated based on screen width
  const getResponsiveStyles = () => {
    if (windowWidth <= 480) {
      return {
        gridTemplateColumns: "1fr",
        textAlign: "center",
        fontSizeTitle: "24px",
        fontSizeSubtitle: "18px",
        fontSizeText: "14px",
        padding: "10px",
        imageWidth: "100%",
        imageMargin: "20px 0",
      };
    } else if (windowWidth <= 1024) {
      return {
        gridTemplateColumns: "1fr", // Ensure stacking on mid-range screens
        textAlign: "center",
        fontSizeTitle: "28px",
        fontSizeSubtitle: "20px",
        fontSizeText: "16px",
        padding: "20px",
        imageWidth: "100%",
        imageMargin: "0",
      };
    }
    return {
      gridTemplateColumns: "1fr 1fr", // Two columns on larger screens
      textAlign: "left",
      fontSizeTitle: "34px",
      fontSizeSubtitle: "24px",
      fontSizeText: "16px",
      padding: "30px",
      imageWidth: "100%",
      imageMargin: "0",
    };
  };
  

  const styles = getResponsiveStyles();

  const imageSlides = [
    Img1,Img2,Img3,Img4,
  ];
  
  const SlideShow = ({ images, width }) => {
    const [current, setCurrent] = useState(0);
    const intervalRef = useRef(null);
  
    const nextSlide = () => {
      setCurrent((prev) => (prev + 1) % images.length);
    };
  
    const prevSlide = () => {
      setCurrent((prev) => (prev - 1 + images.length) % images.length);
    };
  
    useEffect(() => {
      intervalRef.current = setInterval(nextSlide, 3000);
      return () => clearInterval(intervalRef.current);
    }, []);
  
    const handleManualNav = (callback) => {
      clearInterval(intervalRef.current);
      callback();
      intervalRef.current = setInterval(nextSlide, 3000);
    };
  
    return (
      <div style={{ position: "relative", width: "100%" }}>
        <img
          src={images[current]}
          alt={`Slide ${current + 1}`}
          style={{
            width: width,
            height: "auto",
            borderRadius: "8px",
            transition: "all 0.5s ease-in-out",
          }}
        />
        <button onClick={() => handleManualNav(prevSlide)} style={navBtn("left")}>‹</button>
        <button onClick={() => handleManualNav(nextSlide)} style={navBtn("right")}>›</button>
      </div>
    );
  };
  
  const navBtn = (side) => ({
    position: "absolute",
    top: "50%",
    [side]: "10px",
    transform: "translateY(-50%)",
    background: " rgba(255, 255, 255, .4)",
    color: "white",
    border: "none",
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    cursor: "pointer",
    fontSize: "20px",
  });
  

  return (
    <div key={windowWidth} ref={sectionRef} style={{ width: "100%", margin: "100px auto",
      minHeight: "300px",}}>
      {/* First Row */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: styles.gridTemplateColumns,
          gap: "20px",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        {/* Left Column - Text */}
        <div
          style={{
            padding: styles.padding,
            textAlign: styles.textAlign,
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateX(0)" : "translateX(-50px)",
            transition: "all 0.8s ease-in-out",
          }}
        >
          <h2 style={{ fontSize: styles.fontSizeTitle, fontWeight: "bold", color: "#5c0e14" }}>History</h2>
          <h1 style={{ fontSize: styles.fontSizeSubtitle, fontWeight: "bold", color: "grey" }}>
          Our Legacy: Five Decades of Architectural Excellence</h1>

<p>Founded in <strong>1972</strong>, <strong>Samson and Associates</strong> began its journey in partnership with <strong>SS Construction</strong>, 
contributing to <strong>  Industrial construction</strong> and <strong>Entertainment spaces</strong> until <strong>1988</strong>. 
From then on, the firm stood independently, shaping the <strong>Architectural landscape</strong> with 
<strong> Innovative industrial and Residential projects</strong>.</p>

<p>A milestone achievement was the collaboration with the <strong>Central Government Railway Projects</strong>, 
where <strong>Samson and Associates</strong> successfully designed and executed the 
<strong>Station Elevation Work at Thiruthani, Tamil Nadu</strong>—a structure that stands as a testament to 
<strong>Quality and Sustainability</strong> even today.</p>

<p>Led by the visionary <strong>Mr. Samson Sundaram</strong>, the firm has expanded its expertise across 
<strong>Hosur, Chennai, and beyond</strong>, delivering <strong>State-Of-The-Art Industrial Architecture, 
residential projects, and commercial spaces</strong>. With a strong presence in the <strong>Hosur region</strong>, 
<strong>Samson and Associates</strong> continues to redefine <strong>Modern Architecture</strong> with 
<strong>Innovative, Sustainable, and Functional Designs</strong>.</p>

<p>With a deep-rooted passion for <strong>Architectural Transformation</strong>, the firm continues to shape 
the built environment, creating spaces that not only serve the present but inspire future generations.</p>
        </div>

        {/* Right Column - Image */}
        <div
          style={{
            textAlign: "center",
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateX(0)" : "translateX(50px)",
            transition: "all 0.8s ease-in-out 0.3s",
          }}
        >
          <SlideShow images={imageSlides} width={styles.imageWidth} style={{
              width: styles.imageWidth,
              borderRadius: "8px",
              margin: styles.imageMargin,
            }} />
{/* 
          <img
            src="https://img.freepik.com/free-photo/3d-electric-car-building_23-2148972401.jpg"
            alt="Placeholder"
            style={{
              width: styles.imageWidth,
              borderRadius: "8px",
              margin: styles.imageMargin,
            }}
          /> */}
        </div>
      </div>

      {/* Second Row - Full Width Text */}
      <div
        style={{
          textAlign: "center",
          padding: styles.padding,
          background: "#fff8f1",
          borderRadius: "8px",
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "scale(1)" : "scale(0.9)",
          transition: "all 0.8s ease-in-out 0.6s",
        }}
      >
        <p style={{ fontSize: styles.fontSizeText, color: "black" }}>
          <span style={{ fontWeight: "bold" }}>A Legacy of Artistic Excellence -</span> Our Managing Director, Er. G. Samson Sundaram, carries forward the artistic legacy of
          his father, Mr. Gnana Sundaram, a renowned Art Director at Modern Theatres, Salem. This innate artistic sensibility is reflected in every project we undertake,
          ensuring designs that harmonize beauty and functionality.
          <br />
          <br />
          At <span style={{ fontWeight: "bold" }}>SAMSON AND ASSOCIATES</span>, we don’t just design spaces—we create environments where people feel inspired and at home. Our
          expertise, combined with our passion for architecture and engineering, has enabled us to transform spaces across Tamil Nadu and beyond.
        </p>
      </div>
    </div>
  );
};

export default TwoRowLayout;
